import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { translatedMessage } from '../../service/LanguageService';

import DataTableUtils from '../../utilities/DataTableUtils';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import JobViewDialog from '../../pages/competition/JobViewDialog';

const ApplicationJobListViewComponent = (props) => {
    const [application, setApplication] = useState(null);
    const [viewDialogVisible, setViewDialogVisible] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    useEffect(() => {
        // console.log(props.application);
        setApplication(props.application);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const getJobDetails = (data) => {
        return (
            <>
                {data.jobClass && <div><span className="font-bold">{translatedMessage("job.jobClass") + ": "}</span>{data.jobClass}</div>}
                {data.level && <div><span className="font-bold">{translatedMessage("job.level") + ": "}</span>{data.level}</div>}
                {data.departmentType && <div><span className="font-bold">{translatedMessage("job.departmentType") + ": "}</span>{data.departmentType}</div>}
                {data.departmentName && <div><span className="font-bold">{translatedMessage("job.departmentName") + ": "}</span>{data.departmentName}</div>}
            </>
        );
    };

    const getJobLocation = (data) => {
        let hasLocation = data.location
        let _location = data.location ? data.location : (data.institution?.locality ? data.institution?.locality : null)
        let _county = data.jobCounty ? data.jobCounty.label : (data.institution?.county ? data.institution?.county : null)
        return (
            <>
                {data.institution?.name && <div>{data.institution.name}</div>}                
                {_location && <div><span className="font-bold">{hasLocation ? "" : (translatedMessage("generic.locality") + ": ")}</span>{_location}</div>}
                {_county && <div><span className="font-bold">{translatedMessage("generic.county") + ": "}</span>{_county}</div>}
            </>
        );
    };

    const showViewDialog = (_job) => {
        setSelectedJob(_job);
        setViewDialogVisible(true);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions flex flex-wrap align-items-center justify-content-end">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-primary m-1"
                    onClick={() => showViewDialog(rowData)}
                    tooltip={translatedMessage('generic.edit')}
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <div className='col-12 mt-3 mb-3'>
                <h5>{translatedMessage('application.job.paragraphTitle')}</h5>
                {props?.showWarning &&
                    <Message severity="warn" text={translatedMessage("application.validation.jobs")} />
                }
                <DataTable
                    ref={dt}
                    value={application?.jobList}
                    dataKey="id"
                    paginator
                    rows={DataTableUtils.defalRowsPerPage()}
                    rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                    className="datatable-responsive pcn-datatable"
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                    emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                >
                    <Column
                        field="position"
                        header={translatedMessage('job.position')}
                        sortable
                        headerStyle={{ width: '25%', minWidth: '10rem' }}
                        filter
                        showFilterMenu={false}
                    />
                    <Column
                        field="jobClass"
                        header={translatedMessage('generic.details')}
                        sortable
                        headerStyle={{ width: '30%', minWidth: '10rem' }}
                        body={getJobDetails}
                        filter
                        showFilterMenu={false}
                    />
                    <Column
                        field="institution.name"
                        header={translatedMessage('job.location')}
                        sortable
                        headerStyle={{ width: '30%', minWidth: '10rem' }}
                        body={getJobLocation}
                        filter
                        showFilterMenu={false}
                    />
                    <Column body={actionBodyTemplate} />
                </DataTable>
            </div>

            {viewDialogVisible &&
                <JobViewDialog
                    value={selectedJob}
                    visible={viewDialogVisible}
                    visibleSetter={() => setViewDialogVisible(false)}
                />
            }
        </>
    );
};

export default ApplicationJobListViewComponent;
